import { FieldType, ProcurationFeeItemsResponse } from '@pmp/api';
import { ValueList } from '@ohpen/enso-ui';

export const PROCURATION_FEES_VALUE_LIST_NAMES: FieldType[] = [
  FieldType.YES_NO,
  FieldType.PROCURATION_FEE_ITEM_TYPE,
  FieldType.APPLICATION_TYPE,
  FieldType.APPLICANT_TYPES,
  FieldType.OPERATION_TYPE,
  FieldType.PROCURATION_FEE_UNIT,
  FieldType.PROCURATION_FEE_BASIS,
  FieldType.ENDING_TYPE,
  FieldType.PROPERTY_PURPOSE,
];

export const PROCURATION_FEES_ENTITY_LIST_NAMES: FieldType[] = [FieldType.PROCURATION_FEES];

export const getProcurationFeeOptions = (feesResult: ProcurationFeeItemsResponse[] | null | undefined): ValueList =>
  feesResult?.reduce((acc: ValueList, fee: ProcurationFeeItemsResponse) => ({ ...acc, [fee.id]: fee.name ?? fee.id }), {} as ValueList) ??
  {};

export const reorderedItemErrors = (itemErrors: Record<string, any>): Record<number, any> => {
  const { completion, ...rest } = itemErrors;

  return {
    0: completion,
    ...Object.keys(rest)
      .sort((a, b) => Number(a) - Number(b))
      .reduce<Record<number, any>>((acc, key, idx) => {
        acc[idx + 1] = rest[key];
        return acc;
      }, {}),
  };
};
